import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  src: "img/nethealth_logo.png",
  width: "100px"
}
const _hoisted_2 = {
  key: 1,
  src: "/img/patient-portal-long-white.png",
  width: "400px",
  class: "absolute px-4 -ml-4"
}
const _hoisted_3 = { class: "text-white flex align-items-center gap-3" }
const _hoisted_4 = { class: "hidden md:block" }

import { computed, ref } from 'vue';
import {useRouter} from "vue-router";
import { useRootStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'PortalAppHeader.vue3',
  props: {
    showProfile: { type: Boolean, default: false },
    showMessagingHeader: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const rootStore = useRootStore();
const router = useRouter();
const isMobile = computed(() => rootStore.state.isMobile);
const patientDetails = computed(() => rootStore.state.currentPatient);
const setFacilityId = () => rootStore.dispatch('setFacilityId');
const setAccessToken = () => rootStore.dispatch('setAccessToken');

const buttonRef = ref();
const items = ref([
    {
        label: 'Account Settings',
        icon: 'pi pi-cog',
        command: async () => {
            router.push({ path: '/settings' });
        }
    },
    {
        label: 'Log Out',
        icon: 'pi pi-sign-out',
        command: async () => {
            await setAccessToken();
            await setFacilityId();
            router.push({ path: '/login' });
        }
    }
]);

function toggle(event: Event) {
    buttonRef.value.toggle(event)
}

return (_ctx: any,_cache: any) => {
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_menu = _resolveComponent("p-menu")!
  const _component_p_toolbar = _resolveComponent("p-toolbar")!

  return (_openBlock(), _createBlock(_component_p_toolbar, { class: "portal-header-bg z-5 h-3rem p-0 border-noround fixed top-0 w-full px-4 shadow-4" }, _createSlots({ _: 2 }, [
    (_ctx.showMessagingHeader)
      ? {
          name: "start",
          fn: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: "/img/logo_wide.png",
              width: "400px",
              class: "absolute px-8 -ml-4"
            }, null, -1))
          ]),
          key: "0"
        }
      : {
          name: "start",
          fn: _withCtx(() => [
            (isMobile.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_1))
              : (_openBlock(), _createElementBlock("img", _hoisted_2))
          ]),
          key: "1"
        },
    (props.showProfile)
      ? {
          name: "end",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(patientDetails.value.firstName), 1),
              _createVNode(_component_p_button, {
                icon: "mdi mdi-account-circle-outline",
                class: "p-button-rounded p-button-text text-white text-2xl",
                severity: "info",
                "aria-controls": "overlay_menu",
                onClick: toggle
              }),
              _createVNode(_component_p_menu, {
                id: "overlay_menu",
                ref_key: "buttonRef",
                ref: buttonRef,
                class: "menu-top",
                model: items.value,
                popup: true
              }, null, 8, ["model"])
            ])
          ]),
          key: "2"
        }
      : undefined
  ]), 1024))
}
}

})